var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeterChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 191,
    viewBox: "0 0 335 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.361 98.9155C149.69 98.9155 153.687 101.457 153.687 106.173C153.687 108.855 152.039 110.66 149.883 111.659C152.284 112.168 154.826 114.937 154.826 117.9C154.826 122.562 150.654 125.437 144.361 125.437C138.068 125.437 133.896 122.562 133.896 117.9C133.896 114.937 136.438 112.168 138.84 111.659C136.701 110.66 135.018 108.855 135.018 106.173C135.018 101.457 139.05 98.9155 144.361 98.9155ZM144.361 109.626C146.728 109.626 148.463 108.329 148.463 106.085C148.463 103.806 146.728 102.404 144.361 102.404C141.995 102.404 140.259 103.806 140.259 106.085C140.259 108.329 141.995 109.626 144.361 109.626ZM144.361 121.546C147.411 121.546 149.252 120.038 149.252 117.777C149.252 115.481 147.411 113.885 144.361 113.885C141.346 113.885 139.488 115.481 139.488 117.777C139.488 120.038 141.346 121.546 144.361 121.546Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.377 125.437C162.504 125.437 158.244 122.545 157.946 117.97H162.925C163.345 120.003 164.905 121.3 167.167 121.3C170.883 121.3 173.477 118.881 173.056 112.658C172.022 114.587 169.849 115.814 166.956 115.814C161.663 115.814 157.929 112.658 157.929 107.627C157.929 102.509 161.82 98.8629 167.675 98.8629C174.301 98.8629 178.333 103.806 178.333 111.624C178.333 120.897 174.196 125.437 167.377 125.437ZM167.833 111.659C170.041 111.659 172.338 109.924 172.338 108.346C172.355 104.858 170.532 102.789 167.833 102.789C165.379 102.789 163.556 104.63 163.556 107.365C163.556 110.082 165.291 111.659 167.833 111.659Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.149 98.8804C191.83 98.8804 194.652 102.141 194.652 106.313C194.652 110.432 191.883 113.605 188.149 113.605C184.398 113.605 181.576 110.432 181.576 106.313C181.576 102.141 184.45 98.8804 188.149 98.8804ZM206.677 98.9856L189.236 125.367L186.151 125.314L203.645 98.9856H206.677ZM188.114 110.94C189.972 110.94 190.813 109.205 190.813 106.313C190.813 103.333 189.937 101.51 188.114 101.51C186.308 101.51 185.432 103.368 185.432 106.313C185.432 109.188 186.273 110.94 188.114 110.94ZM205.187 110.835C208.886 110.835 211.708 114.131 211.708 118.25C211.708 122.405 208.939 125.577 205.187 125.577C201.436 125.577 198.614 122.405 198.614 118.25C198.614 114.131 201.471 110.835 205.187 110.835ZM205.152 122.878C206.975 122.878 207.834 121.107 207.834 118.285C207.834 115.34 206.94 113.5 205.152 113.5C203.364 113.5 202.47 115.375 202.47 118.285C202.47 121.107 203.347 122.878 205.152 122.878Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M22.9197 89.3654C37.5415 64.3645 58.6229 43.4971 83.9205 29.0033C108.448 14.9495 136.935 6.8959 167.34 6.85589C197.746 6.81589 226.246 14.8028 250.814 28.7766C276.152 43.2038 297.301 64.0045 311.991 88.9653C325.18 111.379 333.153 137.154 334.288 164.661H334.437C334.396 134.66 326.22 106.553 311.991 82.3518C297.301 57.3909 276.166 36.5769 250.814 22.1631C226.246 8.17593 197.733 0.202336 167.34 0.242337C136.935 0.282339 108.448 8.34928 83.9205 22.3898C58.6229 36.8836 37.528 57.7376 22.9197 82.7518C8.74389 106.993 0.662735 135.127 0.703276 165.115H0.851929C1.91951 137.594 9.81149 111.806 22.9333 89.352L22.9197 89.3654Z",
    fill: "url(#paint0_linear_2_437)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6597 163.784C63.0934 163.784 73.1502 155.999 75.4585 144.992C84.3274 102.658 122.557 70.7223 168.238 70.7223C213.918 70.7223 252.148 102.658 261.017 144.992C263.325 155.999 273.368 163.784 284.816 163.784C300.353 163.784 311.827 149.713 308.641 134.766C294.994 70.9212 237.218 22.8451 168.238 22.8451C99.2574 22.8451 41.4949 70.9345 27.8338 134.766C24.6345 149.7 36.1222 163.784 51.6597 163.784Z",
    fill: "url(#paint1_linear_2_437)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.889 102.237C263.847 83.3962 247.952 67.7067 228.868 56.8038C210.365 46.2334 188.915 40.157 166.006 40.157C143.097 40.157 121.634 46.2334 103.145 56.8038C84.0603 67.7067 68.1658 83.3962 57.1235 102.237C47.5949 118.498 41.675 137.086 40.4856 156.924C40.2558 160.673 43.2969 163.851 47.1218 163.851C50.6224 163.851 53.5553 161.192 53.7445 157.748C54.7312 139.825 60.0429 123.032 68.6524 108.366C78.5189 91.5334 92.7374 77.4927 109.794 67.7466C126.338 58.3063 145.516 52.8682 165.993 52.8682C186.469 52.8682 205.661 58.3063 222.191 67.7466C239.248 77.4927 253.466 91.5201 263.333 108.366C271.929 123.045 277.254 139.825 278.241 157.748C278.43 161.179 281.376 163.851 284.863 163.851C288.688 163.851 291.729 160.687 291.5 156.924C290.324 137.073 284.404 118.498 274.862 102.237H274.889Z",
    fill: "#90908F"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.599 115.636L165.392 149.091L171.292 167.57L301.599 115.636Z",
    fill: "#30302F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.789 140.495C166.622 134.175 179.705 137.004 186.01 146.814C192.315 156.624 189.454 169.699 179.62 176.02C169.787 182.34 156.704 179.511 150.399 169.701C144.095 159.891 146.955 146.816 156.789 140.495Z",
    fill: "#30302F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.095 145.64C167.084 141.148 176.38 143.156 180.859 150.124C185.337 157.092 183.302 166.382 176.313 170.874C169.324 175.366 160.028 173.358 155.549 166.39C151.071 159.422 153.106 150.132 160.095 145.64Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.508 149.399C167.412 146.247 173.937 147.658 177.081 152.55C180.226 157.443 178.799 163.964 173.895 167.116C168.991 170.268 162.466 168.857 159.322 163.964C156.177 159.072 157.604 152.551 162.508 149.399Z",
    fill: "#30302F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_437",
    x1: 334.437,
    y1: 82.6985,
    x2: 0.689757,
    y2: 82.6985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6DBF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#A6D13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAED2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EB2B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB2027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_437",
    x1: 309.168,
    y1: 93.3081,
    x2: 27.2938,
    y2: 93.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6DBF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#A6D13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAED2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EB2B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB2027"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeterChart);
export default __webpack_public_path__ + "static/media/meter_chart.6f0c9c96e3efee8997f88567263c9026.svg";
export { ForwardRef as ReactComponent };